import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=e285f50e&"
import script from "./Disclosure.vue?vue&type=script&lang=ts&"
export * from "./Disclosure.vue?vue&type=script&lang=ts&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/Users/markussh/git/theodora-tech-website/src/components/button/Button.vue').default,AnimateExpand: require('/Users/markussh/git/theodora-tech-website/src/components/animate/AnimateExpand.vue').default})
